import { fetchPrice, fetchTransport } from '../../api/vmtplCalcApi';

const GET_VEHICLES = 'efes/vmtpl/GET_VEHICLES';
const GET_VEHICLES_SUCCESS = 'efes/vmtpl/GET_VEHICLES_SUCCESS';
const GET_VEHICLES_FAIL = 'efes/vmtpl/GET_VEHICLES_FAIL';

const GET_PRICE = 'efes/vmtpl/GET_PRICE';
const GET_PRICE_SUCCESS = 'efes/vmtpl/GET_PRICE_SUCCESS';
const GET_PRICE_FAIL = 'efes/vmtpl/GET_PRICE_FAIL';

const initialState = {
  vehicleData: {
    transport: null,
    purpose: null,
  },
  prices: {
    MTPL: null,
    DVPA: null,
    CASCO: null,
  },
  isGettingVehicle: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_VEHICLES:
      return {
        ...state,
        isGettingVehicle: true,
      };
    case GET_VEHICLES_SUCCESS:
      return {
        ...state,
        isGettingVehicle: false,
        vehicleData: {
          transport: action.result,
          purpose: action.result.purposes[0],
        },
      };
    case GET_VEHICLES_FAIL:
      return {
        ...state,
        isGettingVehicle: false,
        getVehiclesError: action.error,
      };
    case GET_PRICE:
      return {
        ...state,
        isGettingPrice: true,
      };
    case GET_PRICE_SUCCESS:
      return {
        ...state,
        isGettingPrice: false,
        prices: { ...state.prices, ...action.result },
      };
    case GET_PRICE_FAIL:
      return {
        ...state,
        isGettingPrice: false,
        getPricesError: action.error,
      };
    default:
      return state;
  }
}

export function getVehicles() {
  return {
    actions: [
      { type: GET_VEHICLES },
      { type: GET_VEHICLES_SUCCESS },
      { type: GET_VEHICLES_FAIL, showError: true },
    ],
    promise: fetchTransport(),
  };
}

export function getPrice(params) {
  return {
    actions: [
      { type: GET_PRICE },
      { type: GET_PRICE_SUCCESS },
      { type: GET_PRICE_FAIL, showError: true, customMsg: 'getPricesFail' },
    ],
    promise: fetchPrice(params).then((data) => data.vehicle_prices[0]),
  };
}
